/* <heimat-lang-switcher> — disclosure behaviour for the Heimat header language
   picker. Deliberately decoupled from Dawn's <localization-form> (that component
   hard-requires .header-wrapper and .menu-drawer, which the Heimat header never
   renders, so it would throw).

   This element ONLY manages open/close + keyboard a11y. The actual language
   switch is a native {% form 'localization' %} submit (each language is a real
   <button type="submit" name="locale_code">), so switching still works with JS
   disabled. The drawer variant is a plain segmented control and needs no JS. */
if (!customElements.get('heimat-lang-switcher')) {
  customElements.define(
    'heimat-lang-switcher',
    class HeimatLangSwitcher extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('[data-heimat-lang-toggle]');
        this.panel = this.querySelector('[data-heimat-lang-panel]');
        this.items = Array.from(this.querySelectorAll('[data-heimat-lang-item]'));
        if (!this.toggle || !this.panel) return;

        this._onDocPointer = this._onDocPointer.bind(this);
        this.toggle.addEventListener('click', () => this.toggleOpen());
        this.addEventListener('keydown', (event) => this._onKeydown(event));
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) this.close();
        });
      }

      get isOpen() {
        return this.toggle.getAttribute('aria-expanded') === 'true';
      }

      toggleOpen() {
        this.isOpen ? this.close() : this.open();
      }

      open() {
        this.toggle.setAttribute('aria-expanded', 'true');
        this.panel.hidden = false;
        document.addEventListener('pointerdown', this._onDocPointer);
        const active = this.items.find((i) => i.classList.contains('is-active')) || this.items[0];
        if (active) requestAnimationFrame(() => active.focus());
      }

      close(returnFocus) {
        if (!this.isOpen) return;
        this.toggle.setAttribute('aria-expanded', 'false');
        this.panel.hidden = true;
        document.removeEventListener('pointerdown', this._onDocPointer);
        if (returnFocus) this.toggle.focus();
      }

      _onDocPointer(event) {
        if (!this.contains(event.target)) this.close();
      }

      _onKeydown(event) {
        if (event.key === 'Escape' && this.isOpen) {
          event.stopPropagation();
          this.close(true);
          return;
        }
        if (!this.isOpen || this.items.length === 0) return;
        const idx = this.items.indexOf(document.activeElement);
        switch (event.key) {
          case 'ArrowDown':
            event.preventDefault();
            (this.items[idx + 1] || this.items[0]).focus();
            break;
          case 'ArrowUp':
            event.preventDefault();
            (this.items[idx - 1] || this.items[this.items.length - 1]).focus();
            break;
          case 'Home':
            event.preventDefault();
            this.items[0].focus();
            break;
          case 'End':
            event.preventDefault();
            this.items[this.items.length - 1].focus();
            break;
        }
      }
    }
  );
}
